import { render, staticRenderFns } from "./impact-details-content.vue?vue&type=template&id=6033a33a&"
import script from "./impact-details-content.vue?vue&type=script&lang=js&"
export * from "./impact-details-content.vue?vue&type=script&lang=js&"
import style0 from "./impact-details-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports